import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Typography, Space, Divider, Button, Dropdown } from 'antd';
const { Text } = Typography;
export const MobileCardView = ({ dataSource, columns, rowKey = 'id', onRow, maxColumns = 3, showActions = false, actionItems, }) => {
    if (!dataSource || dataSource.length === 0) {
        return _jsx("div", { children: "No Data" });
    }
    const getRowKey = (record, index) => {
        if (typeof rowKey === 'function') {
            return rowKey(record);
        }
        return (record[rowKey] || index).toString();
    };
    return (_jsx(Space, { direction: "vertical", style: { width: '100%' }, size: 16, children: dataSource.map((record, index) => (_jsx(Card, { size: "small", style: { width: '100%' }, bodyStyle: { padding: 16 }, onClick: onRow ? (event) => onRow(record, index)?.onClick?.(event) : undefined, children: _jsxs(Space, { direction: "vertical", style: { width: '100%' }, size: 12, children: [columns.slice(0, maxColumns).map((col, colIndex) => {
                        // Type guard to ensure we have a ColumnType (not ColumnGroupType)
                        if (!('dataIndex' in col)) {
                            return null;
                        }
                        const columnType = col;
                        const dataIndex = columnType.dataIndex;
                        const value = record[dataIndex];
                        const render = columnType.render;
                        // Skip columns without dataIndex/title
                        if (!columnType.title && !columnType.dataIndex) {
                            return null;
                        }
                        return (_jsxs("div", { children: [_jsxs(Text, { strong: true, style: { fontSize: 14 }, children: [String(columnType.title), ":", ' '] }), _jsx(Text, { style: { fontSize: 14 }, children: render ? String(render(value, record, index)) : String(value || '-') }), colIndex < Math.min(columns.length, maxColumns) - 1 && (_jsx(Divider, { style: { margin: '8px 0' } }))] }, colIndex));
                    }), showActions && actionItems && (_jsx("div", { style: { marginTop: 8 }, children: _jsx(Dropdown, { menu: {
                                items: actionItems(record).map(item => ({
                                    key: item.key,
                                    label: item.label,
                                    icon: item.icon,
                                    onClick: item.onClick,
                                    danger: item.danger,
                                })),
                            }, trigger: ['click'], children: _jsx(Button, { type: "text", size: "small", children: "Actions" }) }) }))] }) }, getRowKey(record, index)))) }));
};
export default MobileCardView;
//# sourceMappingURL=MobileCardView.js.map